import { useEffect } from 'react';
import { Switch, Route, RouteProps, useHistory } from 'react-router-dom';
import environmentConfig from '../environment-configs';
import { useAuth } from '../../hooks/useAuth';
import EditUserData from '../../pages/EditUserData';
import FamilyPage from '../../pages/FamilyPage';
import DownloadData from '../../pages/DownloadData';
import DeleteAccount from '../../pages/DeleteAccount';
import ChangeEmailPage from '../../pages/ChangeEmail';
import ConfirmChangeEmailPage from '../../pages/ConfirmChangeEmail';
import RollbackEmailPage from '../../pages/RollbackEmail';
import ChangePasswordPage from '../../pages/ChangePassword';

import HomePage from '../../pages/HomePage';
import ParentalConsent from '../../pages/ParentalConsent';
import CommunicationPreferences from '../../pages/CommunicationPreferences';
import AssociateAccounts from '../../pages/AssociateAccounts';
import ManagerAccounts from '../../pages/ManagerAccounts';

interface CustomRouteProps extends RouteProps {
  isPrivate?: boolean;
}

function CustomRoute({ isPrivate, ...props }: CustomRouteProps) {
  const { privateRoute, authenticated } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (isPrivate) {
      privateRoute();
    }
  }, [isPrivate, privateRoute]);

  useEffect(() => {
    const param = localStorage.getItem('redirect');

    if (authenticated && param) {
      localStorage.removeItem('redirect');

      window.history.replaceState({}, '', window.location.pathname);

      if (param) {
        history.push(`/${param}`);
      } else {
        window.location.replace(environmentConfig.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL);
      }
    }
  }, [authenticated, history]);

  return <Route {...props} />;
}

CustomRoute.defaultProps = {
  isPrivate: false,
};

const RedirectToMinhaContaV3 = () => {

  const isHomePath = Boolean(
    window.location.href === `${environmentConfig.ACCOUNT_MANAGEMENT_URL}/` || 
    window.location.href === `${environmentConfig.ACCOUNT_MANAGEMENT_URL}/#/`
  );

  useEffect(() => {
    if (isHomePath && environmentConfig.ENVIROMENT !== 'local') {
      window.location.replace(environmentConfig.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL);
    }
  }, []);

  if (isHomePath && environmentConfig.ENVIROMENT !== 'local') {
    return null;
  }

  return <HomePage />;
};

export function Routes() {
  return (
    <Switch>
      <CustomRoute
        isPrivate
        path="/"
        component={RedirectToMinhaContaV3}
        exact
      />
      <CustomRoute
        isPrivate
        path="/alterar-dados"
        component={EditUserData}
        exact
      />
      <CustomRoute isPrivate path="/familia" component={FamilyPage} exact />
      <CustomRoute
        isPrivate
        path="/download-data"
        component={DownloadData}
        exact
      />
      <CustomRoute
        isPrivate
        path="/gestao-comunicados"
        component={CommunicationPreferences}
        exact
      />
      <CustomRoute
        isPrivate
        path="/excluir-conta"
        component={DeleteAccount}
        exact
      />
      <CustomRoute
        isPrivate
        path="/excluir-conta/confirma-senha/:reasonId/:step"
        component={DeleteAccount}
        exact
      />
      <CustomRoute
        isPrivate
        path="/email/change"
        component={ChangeEmailPage}
        exact
      />
      <CustomRoute path="/email" component={ConfirmChangeEmailPage} exact />
      <CustomRoute path="/email/rollback" component={RollbackEmailPage} exact />
      <CustomRoute
        isPrivate
        path={[
          '/consentimento-parental/:underageId',
          '/consentimento-parental/:underageId/confirma-senha/:confirmID/:step',
        ]}
        component={ParentalConsent}
        exact
      />
      <CustomRoute
        isPrivate
        path="/alterar-senha"
        component={ChangePasswordPage}
        exact
      />
      <CustomRoute
        isPrivate
        path="/associate-accounts"
        component={AssociateAccounts}
        exact
      />
      <CustomRoute
        isPrivate
        path="/manager-accounts"
        component={ManagerAccounts}
        exact
      />
    </Switch>
  );
}
